import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CollectionDto } from '../model/collection.model';
import { environment } from '../../environments/environment';
import { HttpClientHelper } from './http-client-helper.service';
import { firstValueFrom, map, tap } from 'rxjs';
import { ConsoleLoggerService } from "./console-logger.service";
import { LocationInventoryListItem } from "../model/location-inventory-list-item.model";
import { ToolInventoryListItem } from '../model/tool-inventory-list-item.model';
import { ToolInventoryAmount } from '../model/tool-inventory-amount.model';
import { CantaaErrorHandlerService } from './cantaa-error-handler.service';
import {ProjectConsumptionToolListItem} from '../model/project-consumption-tool-list.item';
import {GridRequest} from '../model/grid-request.model';


@Injectable({
  providedIn: 'root'
})
export class ProjectConsumptionService {

  constructor(private http: HttpClient,
              private httpClientHelper: HttpClientHelper,
              private log: ConsoleLoggerService,
              private errorHandler: CantaaErrorHandlerService) {
  }

  getProjectConsumption(toolId: number | undefined, gridRequest: GridRequest) {
    let url = environment.apiUrl + `/project-consumption/${toolId}`;
    const params = this.httpClientHelper.createHttpParams();
    let observable = this.http.post<CollectionDto<ProjectConsumptionToolListItem>>(url, gridRequest, { params: params })
      .pipe(tap(r => this.log.debug('project consumption: ', r)));
    return firstValueFrom(observable);
  }
}
